import { Component, OnInit } from '@angular/core';
import { ToasterConfig } from 'angular2-toaster/angular2-toaster';

@Component({
  selector: 'mc-toast',
  template: `
    <toaster-container [toasterconfig]="toasterconfig" ></toaster-container>
  `,
  styles: []
})
export class ToastComponent implements OnInit {

  toasterconfig: ToasterConfig =
  new ToasterConfig({
    showCloseButton: { 'success': false, 'error': true },
    tapToDismiss: true,
    mouseoverTimerStop: true,
    timeout: 4000,
    newestOnTop: false,
    positionClass: 'toast-bottom-right'
  });

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/toast/toast.component.ts